<div class="pr-4 pt-3">
  <button
    type="button"
    [mat-dialog-close]="true"
    class="close btn btn-xs btn-icon btn-light btn-hover-primary"
    data-dismiss="modal"
    aria-hidden="true"
  >
    <i class="ki ki-close icon-xs text-muted"></i>
  </button>
</div>
<div
  #wizard
  id="kt_wizard_v3"
  class="card-body wizard wizard-3 navi-hover"
  data-wizard-state="step-first"
>
  <div class="kt-grid__item">
    <!--begin: Form Wizard Nav -->
    <div class="wizard-nav border-bottom mb-1 mb-lg-5">
      <div class="wizard-steps px-8 py-8 px-lg-15 py-lg-3">
        <a class="wizard-step" data-wizard-type="step" data-wizard-state="current">
          <div class="wizard-label">
            <div class="wizard-title"><span>1</span> Sales Team Definition</div>
            <div class="wizard-bar"></div>
          </div>
        </a>
        <a class="wizard-step" data-wizard-type="step">
          <div class="wizard-label">
            <div class="wizard-title"><span>2</span> Define Target Area</div>
            <div class="wizard-bar"></div>
          </div>
        </a>
      </div>
    </div>
    <!--end: Form Wizard Nav -->
  </div>
  <!--begin: Form Wizard Form-->
  <!--begin: Form Wizard Step 0-->
  <form class="form" [formGroup]="salesTeamForm">
    <div class="pb-5" data-wizard-type="step-content" data-wizard-state="current">
      <div class="first-card-form">
        <div class="form-group row" style="padding-top: 0; padding-bottom: 0; max-height: 400px">
          <div class="col-12 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>Team Name</mat-label>
              <input matInput formControlName="name" required />
              <mat-error *ngIf="isControlHasError('name', 'required')">
                Team Name field is required
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-12 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label>Type</mat-label>
              <mat-select formControlName="type">
                <mat-option value="FIELD_SALES">Field Sales</mat-option>
                <mat-option value="INSIDE_SALES">Inside Sales</mat-option>
                <mat-option value="OTHER">Other</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-12 kt-margin-bottom-20-mobile">
            <kt-general-autocomplete
              [label]="'Manager'"
              [loadItemsFunction]="loadMembers"
              [optionFormatter]="stringUtils.displayUserName"
              [valueFormatter]="stringUtils.displayUserName"
              [required]="false"
              [control]="salesTeamForm.get('manager')"
              [change]="onOrganizerChange.bind(this)"
              [dataPath]="'data'"
              [placeholder]="'Select Manager'"
              #organizerAutocomplete
            ></kt-general-autocomplete>
          </div>
          <div class="col-12 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label>Calls on </mat-label>
              <mat-select formControlName="calls_on">
                <mat-option value="DOCTOR">Doctor</mat-option>
                <mat-option value="FACILITY">Facility</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-12 kt-margin-bottom-20-mobile">
            <kt-general-autocomplete
              [appearance]="'fill'"
              [label]="'Members'"
              [loadItemsFunction]="loadMembers"
              [optionFormatter]="stringUtils.displayUserName"
              [valueFormatter]="stringUtils.displayUserName"
              [required]="false"
              [readOnly]="false"
              [control]="salesTeamForm.get('members')"
              [change]="onMemberChange.bind(this)"
              [dataPath]="'data'"
              [placeholder]="'Members'"
              [formatNewObjectFn]="newMemberObject"
              [chipList]="true"
              [objects]="salesTeamForm.get('members').value"
              #membersAutocomplete
            ></kt-general-autocomplete>
          </div>
        </div>
      </div>
    </div>
    <!--end: Form Wizard Step 0-->

    <!--begin: Form Wizard Step 1-->
    <div class="pb-5" data-wizard-type="step-content">
      <div
        class="max-height navi-hover scroll card-body"
        [perfectScrollbar]="{ wheelPropagation: false }"
      >
        <kt-alert
          *ngIf="filterIncorrect"
          type="warn"
          [duration]="30000"
          [showCloseButton]="true"
          (closeAl)="filterIncorrect = false"
        >
          <span>Please select an criteria and it's values</span>
        </kt-alert>
        <div class="row">
          <div
            class="col-lg-6 kt-margin-bottom-20-mobile"
            style="margin-bottom: 20px; margin-left: 15px"
          >
            <div class="p-2 bd-highlight">
              <mat-label class="row">Filter Type</mat-label>
              <mat-slide-toggle
                class="row mt-2 mr-2"
                formControlName="filterType"
              ></mat-slide-toggle>
              <mat-hint align="start">
                <strong>{{ filterTypeHint() }}</strong>
              </mat-hint>
            </div>
          </div>
          <div class="col-lg-12 kt-margin-bottom-20-mobile" style="margin-bottom: 20px">
            <mat-form-field appearance="outline" class="mat-form-field-fluid">
              <mat-label>Criteria</mat-label>
              <mat-select
                formControlName="filterCriteria"
                (selectionChange)="changeValuesInput($event)"
              >
                <mat-option value="ZIP_CODE">Zip Code</mat-option>
                <mat-option value="STATE">State</mat-option>
                <mat-option value="SPECIALTY">Specialty</mat-option>
                <mat-option value="AFFILIATION">Affiliation</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <br />
          <div class="col-lg-12 kt-margin-bottom-20-mobile" style="margin-bottom: 20px">
            <mat-form-field
              class="example-chip-list"
              appearance="outline"
              *ngIf="valueInputType === 'ZIP_CODE'"
            >
              <mat-label>Values</mat-label>
              <mat-chip-list #chipList aria-label="zip selection" [formControl]="zipCtrl">
                <mat-chip *ngFor="let zip of zips" (removed)="removeZip(zip)">
                  {{ zip }}
                  <button matChipRemove class="remove-chip-btn">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip>
                <input
                  maxlength="10"
                  placeholder="Values"
                  #zipInput
                  [matChipInputFor]="chipList"
                  [ngModel]="zipValue"
                  [ngModelOptions]="{ standalone: true }"
                  (ngModelChange)="zipValue = $event ? putDash($event) : ''"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  (matChipInputTokenEnd)="addZip($event)"
                />
              </mat-chip-list>
              <mat-error style="margin-top: 12px" *ngIf="zipCtrl.hasError('pattern')">
                Values field is invalid
              </mat-error>
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              class="mat-form-field-fluid"
              *ngIf="valueInputType === 'STATE'"
            >
              <mat-label>State</mat-label>
              <mat-select [formControl]="stateCtrl" multiple>
                <mat-option value="AL">AL</mat-option>
                <mat-option value="AK">AK</mat-option>
                <mat-option value="AR">AR</mat-option>
                <mat-option value="AZ">AZ</mat-option>
                <mat-option value="CA">CA</mat-option>
                <mat-option value="CO">CO</mat-option>
                <mat-option value="CT">CT</mat-option>
                <mat-option value="DC">DC</mat-option>
                <mat-option value="DE">DE</mat-option>
                <mat-option value="FL">FL</mat-option>
                <mat-option value="GA">GA</mat-option>
                <mat-option value="HI">HI</mat-option>
                <mat-option value="IA">IA</mat-option>
                <mat-option value="ID">ID</mat-option>
                <mat-option value="IL">IL</mat-option>
                <mat-option value="IN">IN</mat-option>
                <mat-option value="KS">KS</mat-option>
                <mat-option value="KY">KY</mat-option>
                <mat-option value="LA">LA</mat-option>
                <mat-option value="MA">MA</mat-option>
                <mat-option value="MD">MD</mat-option>
                <mat-option value="ME">ME</mat-option>
                <mat-option value="MI">MI</mat-option>
                <mat-option value="MN">MN</mat-option>
                <mat-option value="MO">MO</mat-option>
                <mat-option value="MS">MS</mat-option>
                <mat-option value="MT">MT</mat-option>
                <mat-option value="NC">NC</mat-option>
                <mat-option value="NE">NE</mat-option>
                <mat-option value="NH">NH</mat-option>
                <mat-option value="NJ">NJ</mat-option>
                <mat-option value="NM">NM</mat-option>
                <mat-option value="NV">NV</mat-option>
                <mat-option value="NY">NY</mat-option>
                <mat-option value="ND">ND</mat-option>
                <mat-option value="OH">OH</mat-option>
                <mat-option value="OK">OK</mat-option>
                <mat-option value="OR">OR</mat-option>
                <mat-option value="PA">PA</mat-option>
                <mat-option value="PR">PR</mat-option>
                <mat-option value="RI">RI</mat-option>
                <mat-option value="SC">SC</mat-option>
                <mat-option value="SD">SD</mat-option>
                <mat-option value="TN">TN</mat-option>
                <mat-option value="TX">TX</mat-option>
                <mat-option value="UT">UT</mat-option>
                <mat-option value="VT">VT</mat-option>
                <mat-option value="VA">VA</mat-option>
                <mat-option value="WA">WA</mat-option>
                <mat-option value="WI">WI</mat-option>
                <mat-option value="WV">WV</mat-option>
                <mat-option value="WY">WY</mat-option>
              </mat-select>
            </mat-form-field>
            <div [hidden]="valueInputType !== 'AFFILIATION'">
              <kt-general-autocomplete
                [appearance]="'outline'"
                [label]="'Affiliation'"
                [loadItemsFunction]="affiliationAutocompleteCall"
                [optionFormatter]="stringUtils.displayUserName"
                [valueFormatter]="stringUtils.displayUserName"
                [required]="true"
                [readOnly]="false"
                [control]="affiliationCtrl"
                [change]="onAffiliationChange.bind(this)"
                [dataPath]="'data'"
                [placeholder]="'Affiliation'"
                [formatNewObjectFn]="newMemberObject"
                [chipList]="true"
                [objects]="affiliationCtrl.value"
                #affiliationAutocomplete
              ></kt-general-autocomplete>
            </div>
            <div [hidden]="valueInputType !== 'SPECIALTY'">
              <kt-general-autocomplete
                [label]="'Specialties'"
                [appearance]="'outline'"
                [loadItemsFunction]="specialtiesAutocompleteCall"
                [optionFormatter]="stringUtils.displaySpecialties"
                [valueFormatter]="stringUtils.displaySpecialties"
                [required]="true"
                [control]="specialitiesCtrl"
                [objects]="specialitiesCtrl.value"
                [change]="onSpecialtiesChange.bind(this)"
                [chipList]="true"
                [formatNewObjectFn]="formatNewSpecialtiesFn"
                [dataPath]="'data'"
                [placeholder]="'Select Specialty'"
                #specialtiesAutocomplete
              ></kt-general-autocomplete>
            </div>
          </div>

          <div
            class="col-lg-3 kt-margin-bottom-20-mobile padding-top-4"
            style="margin-bottom: 20px"
          >
            <button
              type="button"
              (click)="addFilter()"
              class="btn btn-primary add-button font-weight-bold"
            >
              Add
            </button>
          </div>
        </div>
        <div class="" *ngIf="filtersJson.length > 0">
          <div class="list">
            <div
              class="col-lg-12 kt-margin-bottom-20-mobile example-box"
              style="margin-bottom: 10px"
            >
              <div class="row">
                <div class="col-lg-12 kt-margin-bottom-20-mobile" style="padding-left: 0">
                  <div
                    class="d-flex justify-content-around bd-highlight"
                    style="background-color: whitesmoke; border-radius: 6px"
                  >
                    <table style="width: 100%">
                      <tr>
                        <td style="text-align: center; width: 10%"><strong>Filter Type</strong></td>
                        <td style="text-align: center; width: 15%"><strong>Criteria</strong></td>
                        <td style="text-align: center"><strong>Values</strong></td>
                        <td style="text-align: end; width: 10%"></td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-lg-12 kt-margin-bottom-20-mobile example-box"
              style="margin-bottom: 10px"
              *ngFor="let filter of filtersJson; let i = index"
            >
              <div class="row">
                <div class="col-lg-12 kt-margin-bottom-20-mobile" style="padding-left: 0">
                  <div
                    class="d-flex justify-content-around bd-highlight"
                    style="background-color: whitesmoke; border-radius: 6px"
                  >
                    <table style="width: 100%" *ngIf="filter">
                      <tr>
                        <td style="text-align: center; width: 10%">{{ filter.type }}</td>
                        <td style="text-align: center; width: 15%">{{ filter.criteria }}</td>
                        <td style="text-align: center">
                          <span>
                            <span
                              class="pr-1 pl-1 cursor"
                              *ngFor="let value of filter.values; let i = index"
                              [class.border-right]="i !== filter.values.length - 1"
                              >{{
                                value.id
                                  ? value.description
                                    ? value.description
                                    : value.name
                                  : value
                              }}</span
                            >
                          </span>
                        </td>
                        <td style="text-align: end; width: 10%">
                          <button
                            matTooltip="Edit Filter"
                            (click)="editFilter(filter); removeFilter(filter)"
                            class="btn btn-icon btn-light btn-hover btn-xs margin-2"
                          >
                            <span class="svg-icon svg-icon-nm">
                              <span
                                inlineSVG="./assets/media/svg/icons/General/edit_icon.svg"
                              ></span>
                            </span></button
                          >&nbsp;
                          <button
                            matTooltip="Remove Filter"
                            (click)="removeFilter(filter)"
                            class="btn btn-icon btn-light btn-hover btn-xs margin-2"
                          >
                            <span class="svg-icon svg-icon-nm">
                              <span
                                inlineSVG="./assets/media/svg/icons/General/delete_icon.svg"
                              ></span>
                            </span>
                          </button>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>

  <!--end: Form Wizard Step 1-->

  <!--begin: Form Actions -->
  <div class="d-flex justify-content-between footer-wiz">
    <div class="mr-2">
      <div
        class="btn btn-light-primary font-weight-bold text-uppercase"
        data-wizard-type="action-prev"
      >
        <span translate="GLOBAL.PREVIOUS">Previous</span>
      </div>
    </div>
    <div>
      <div
        (click)="onSubmit()"
        class="btn btn-primary font-weight-bold text-uppercase"
        data-wizard-type="action-submit"
      >
        <span translate="GLOBAL.SAVE">Save</span>
      </div>
      <div class="btn btn-primary font-weight-bold text-uppercase" data-wizard-type="action-next">
        <span translate="GLOBAL.NEXTSTEP">Next Step</span>
      </div>
    </div>
  </div>
  <!--end: Form Wizard Form-->
</div>
